import React, { Component } from "react";
import withServices from "src/HOCs/withServices";
import NavBar from "src/components/CustomNav/CustomNav.Component";
import SimpleLoader from "src/components/SimpleLoader/SimpleLoader.Component";
import { toast, ToastContainer } from "react-toastify";
import { CSSTransition } from "react-transition-group";
import Loader from "react-loader";
import assessmentIcon from "../../assets/images/assessment-icon.svg";
import Radio from "@material-ui/core/Radio";
import "./assessmentViewPage.css";

const sample = {
  question: {
    AssessmentQuestionId: 124567069189242,
    Question: "Do you have a trusted adult you can talk to?",
    DisplayOrder: 1,
    isDisplayGraphic: false,
    Icon: "N/A",
    CreatedDateTime: "2025-11-17T14:56:31.951792+00:00",
    UpdatedDateTime: "2025-11-17T14:56:31.951792+00:00",
    Assessment_id: 119,
    AssessmentQuestionGroup_id: 19,
  },
  answers: [
    {
      id: 125683093365086,
      text: "Thank you for your response.",
      AnswerCopy: "Yes",
      score: 0.0,
      DisplayOrder: 1,
      CreatedDateTime: "2025-11-17T15:04:18.705991+00:00",
      UpdatedDateTime: "2025-11-17T15:04:18.705991+00:00",
      Assessment_id: 119,
      AssessmentQuestion_id: 124567069189242,
      Icon: "N/A",
    },
    {
      id: 125683093365087,
      text: "Thank you for your response.",
      AnswerCopy: "No",
      score: 0.0,
      DisplayOrder: 2,
      CreatedDateTime: "2025-11-17T15:05:22.503796+00:00",
      UpdatedDateTime: "2025-11-17T15:05:22.503796+00:00",
      Assessment_id: 119,
      AssessmentQuestion_id: 124567069189242,
      Icon: "N/A",
    },
  ],
};

class ExtraAssessmentPage extends Component<
  { services: any; history: any },
  {
    submitClicked: boolean;
    loaded: boolean;
    selectedAnswerIds: any[];
    answers: any[];
    question: any;
    selectedAnswer: any;
  }
> {
  public state = {
    submitClicked: false,
    loaded: false,
    selectedAnswerIds: [] as any[],
    answers: [] as any[],
    question: {} as any,
    selectedAnswer: null,
  };

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.onSubmitAnswers = this.onSubmitAnswers.bind(this);
  }

  public async componentDidMount() {
    const completedRes =
      await this.props.services.studentsAPI.checkExtraAssessmentCompletion();
    if (completedRes.ok) {
      if (completedRes.data.answered) {
        toast.info(
          "You have already answered this question. Please proceed to your dashboard."
        );
        this.props.history.push("/");
      } else {
        const getExtraAssessmentQuestionsRes =
          await this.props.services.studentsAPI.getExtraAssessmentQuestions();
        if (getExtraAssessmentQuestionsRes.ok) {
          this.setState({
            question: getExtraAssessmentQuestionsRes.data.question,
            answers: getExtraAssessmentQuestionsRes.data.answers,
            loaded: true,
          });
        }
      }
    } else {
      toast.error("Failed to check extra assessment completion");
      this.props.history.push("/");
    }
  }

  public onLogout() {
    this.props.history.push("/login");
  }

  public async onSubmitAnswers() {
    const selectedAnswerIds = this.state.selectedAnswerIds;
    if (selectedAnswerIds.length > 0) {
      const item = {
        answer_ids: selectedAnswerIds,
      };
      const submitRes =
        await this.props.services.studentsAPI.submitExtraAssessmentAnswers(
          item
        );
      if (submitRes.ok) {
        toast.success("Thank you for your response!");
        this.props.history.push("/");
      } else {
        toast.error("Failed to submit answer, please try again.");
      }
    } else {
      toast.error("Please select an answer");
      return;
    }
  }

  public onAnswerSelected(val) {
    const currentSelectedAnswerIds = this.state.selectedAnswerIds;
    if (currentSelectedAnswerIds.includes(val)) {
      this.setState({
        selectedAnswerIds: currentSelectedAnswerIds.filter((id) => id !== val),
      });
    } else {
      currentSelectedAnswerIds.push(val);
      this.setState({
        selectedAnswerIds: currentSelectedAnswerIds,
      });
    }
  }

  public render() {
    const { submitClicked, selectedAnswerIds } = this.state;
    return (
      <div>
        <NavBar logoutParent={this.onLogout} />
        <ToastContainer />
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="assessment-main-container">
            {submitClicked ? (
              <SimpleLoader text="PLEX is working..." />
            ) : (
              <Loader
                loaded={this.state.loaded}
                style={{ width: "80%", overflowY: "scroll" }}
              >
                <div className="assessment-wrapper">
                  <div className="questions-container">
                    <div className="assessment-thumb">
                      <img src={assessmentIcon} alt="Icon of stationery" />
                    </div>
                    <div style={{ marginTop: "3em" }}>
                      <h2 className="extra-assessment-question">
                        DO YOU HAVE AN ADULT OUTSIDE OF YOUR IMMEDIATE OR EXTENDED FAMILY THAT YOU CAN TRUST? IF SO, WHO ARE THEY? </h2>
                        <p className="extra-assessment-question">BY AN ADULT THAT YOU TRUST, WE MEAN SOMEONE YOU CAN GO TO WITH PERSONAL INFORMATION LIKE THINGS YOU ARE WORRIED ABOUT OR THINGS THAT HAVE HAPPENED TO YOU. 

                        </p>
                        <p className="extra-assessment-question">PLEASE SELECT ALL THAT APPLY</p>
                      <ul>
                        {this.state.answers
                          .sort((a, b) => a.DisplayOrder - b.DisplayOrder)
                          .map((answer) => (
                            <li
                              key={answer.id}
                              className="answer-option"
                              style={
                                this.state.selectedAnswerIds.includes(answer.id)
                                  ? { backgroundColor: "#4d4d4d" }
                                  : {}
                              }
                              onClick={this.onAnswerSelected.bind(
                                this,
                                answer.id
                              )}
                            >
                              <Radio
                                checked={this.state.selectedAnswerIds.includes(
                                  answer.id
                                )}
                                id={answer.id.toString()}
                                value={answer.id.toString()}
                                className="radio-button"
                              />

                              <label htmlFor={answer.AnswerCopy}>
                                {answer.AnswerCopy}
                              </label>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                  <p className="extra-assessment-description">
                    This question helps us learn more about how young people are
                    supported at home. It’s completely your choice how you
                    answer. Nothing you say here will change your results or the
                    way your report is worked out. Pick the option that fits you
                    best.
                  </p>
                </div>
              </Loader>
            )}

            <footer className="assessment-footer">
              <button
                onClick={this.onSubmitAnswers}
                disabled={selectedAnswerIds.length === 0}
                className="next-button"
              >
                Submit
              </button>
            </footer>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default withServices(ExtraAssessmentPage);



// WEBPACK FOOTER //
// ./src/pages/Assessments/ExtraAssessmentPage.tsx